/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDevices } from 'app/entities/device/device.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getHospitalManagers } from 'app/entities/hospital-manager/hospital-manager.reducer';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { EquipmentType } from 'app/shared/model/enumerations/equipment-type.model';
import { createEntity, getEntity, reset, updateEntity } from './equipment-ip.reducer';

export const EquipmentIPUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const devices = useAppSelector(state => state.device.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const hospitalManagers = useAppSelector(state => state.hospitalManager.entities);
  const equipmentIPEntity = useAppSelector(state => state.equipmentIP.entity);
  const loading = useAppSelector(state => state.equipmentIP.loading);
  const updating = useAppSelector(state => state.equipmentIP.updating);
  const updateSuccess = useAppSelector(state => state.equipmentIP.updateSuccess);
  const chargeTypeValues = Object.keys(ChargeType);
  const equipmentTypeValues = Object.keys(EquipmentType);

  const handleClose = () => {
    navigate(`/equipment-ip${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDevices({}));
    dispatch(getHospitals({}));
    dispatch(getHospitalManagers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.charge !== undefined && typeof values.charge !== 'number') {
      values.charge = Number(values.charge);
    }
    if (values.expiryDate !== undefined && typeof values.expiryDate !== 'number') {
      values.expiryDate = Number(values.expiryDate);
    }
    if (values.maxUses !== undefined && typeof values.maxUses !== 'number') {
      values.maxUses = Number(values.maxUses);
    }
    if (values.mfdDate !== undefined && typeof values.mfdDate !== 'number') {
      values.mfdDate = Number(values.mfdDate);
    }
    if (values.dateSupended !== undefined && typeof values.dateSupended !== 'number') {
      values.dateSupended = Number(values.dateSupended);
    }
    if (values.maintainanceCycle !== undefined && typeof values.maintainanceCycle !== 'number') {
      values.maintainanceCycle = Number(values.maintainanceCycle);
    }
    if (values.lastMaintenanceDate !== undefined && typeof values.lastMaintenanceDate !== 'number') {
      values.lastMaintenanceDate = Number(values.lastMaintenanceDate);
    }

    const entity = {
      ...equipmentIPEntity,
      ...values,
      device: devices.find(it => it.id.toString() === values.device?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      addedBy: hospitalManagers.find(it => it.id.toString() === values.addedBy?.toString()),
      modifiedBy: hospitalManagers.find(it => it.id.toString() === values.modifiedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          chargeType: 'HOURLY',
          equipmentType: 'ANESTHESIAMACHINE',
          ...equipmentIPEntity,
          device: equipmentIPEntity?.device?.id,
          hospital: equipmentIPEntity?.hospital?.id,
          addedBy: equipmentIPEntity?.addedBy?.id,
          modifiedBy: equipmentIPEntity?.modifiedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.equipmentIP.home.createOrEditLabel" data-cy="EquipmentIPCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.equipmentIP.home.createOrEditLabel">Create or edit a EquipmentIP</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="equipment-ip-id"
                  label={translate('tinyMedicRestApp.equipmentIP.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.microSec')}
                id="equipment-ip-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.timestampentry')}
                id="equipment-ip-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.lastupdated')}
                id="equipment-ip-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.cursor')}
                id="equipment-ip-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.active')}
                id="equipment-ip-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.charge')}
                id="equipment-ip-charge"
                name="charge"
                data-cy="charge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.chargeType')}
                id="equipment-ip-chargeType"
                name="chargeType"
                data-cy="chargeType"
                type="select"
              >
                {chargeTypeValues.map(chargeType => (
                  <option value={chargeType} key={chargeType}>
                    {translate(`tinyMedicRestApp.ChargeType.${chargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.allotted')}
                id="equipment-ip-allotted"
                name="allotted"
                data-cy="allotted"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.supended')}
                id="equipment-ip-supended"
                name="supended"
                data-cy="supended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.expiryDate')}
                id="equipment-ip-expiryDate"
                name="expiryDate"
                data-cy="expiryDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.maxUses')}
                id="equipment-ip-maxUses"
                name="maxUses"
                data-cy="maxUses"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.notes')}
                id="equipment-ip-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.deviceNo')}
                id="equipment-ip-deviceNo"
                name="deviceNo"
                data-cy="deviceNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.deviceName')}
                id="equipment-ip-deviceName"
                name="deviceName"
                data-cy="deviceName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.mfdDate')}
                id="equipment-ip-mfdDate"
                name="mfdDate"
                data-cy="mfdDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.dateSupended')}
                id="equipment-ip-dateSupended"
                name="dateSupended"
                data-cy="dateSupended"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.reasonSupended')}
                id="equipment-ip-reasonSupended"
                name="reasonSupended"
                data-cy="reasonSupended"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.maintainanceCycle')}
                id="equipment-ip-maintainanceCycle"
                name="maintainanceCycle"
                data-cy="maintainanceCycle"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.lastMaintenanceDate')}
                id="equipment-ip-lastMaintenanceDate"
                name="lastMaintenanceDate"
                data-cy="lastMaintenanceDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.tax')}
                id="equipment-ip-tax"
                name="tax"
                data-cy="tax"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.underMaintainance')}
                id="equipment-ip-underMaintainance"
                name="underMaintainance"
                data-cy="underMaintainance"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.equipmentType')}
                id="equipment-ip-equipmentType"
                name="equipmentType"
                data-cy="equipmentType"
                type="select"
              >
                {equipmentTypeValues.map(equipmentType => (
                  <option value={equipmentType} key={equipmentType}>
                    {translate(`tinyMedicRestApp.EquipmentType.${equipmentType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentIP.location')}
                id="equipment-ip-location"
                name="location"
                data-cy="location"
                type="text"
              />
              <ValidatedField
                id="equipment-ip-device"
                name="device"
                data-cy="device"
                label={translate('tinyMedicRestApp.equipmentIP.device')}
                type="select"
              >
                <option value="" key="0" />
                {devices
                  ? devices.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-ip-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.equipmentIP.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="equipment-ip-addedBy"
                name="addedBy"
                data-cy="addedBy"
                label={translate('tinyMedicRestApp.equipmentIP.addedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitalManagers
                  ? hospitalManagers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="equipment-ip-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                label={translate('tinyMedicRestApp.equipmentIP.modifiedBy')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalManagers
                  ? hospitalManagers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/equipment-ip" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EquipmentIPUpdate;
